import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { User, UserProfileUpdate } from '@type/user'
import normalizeUser from '@utils/normalizeUser'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

const UpdateUser = (data: UserProfileUpdate): Promise<User> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.USER
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.patch(URL, data, config)
      .then((res) => {
        const user: User = normalizeUser(res.data)
        resolve(user)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
export default UpdateUser
